import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import ChatBot from "./ChatBot";

const ChatBotWrapper = () => {
  const location = useLocation();
  const [showChatBot, setShowChatBot] = useState(false);

  const excludedPaths = [
    "/",
    "/register",
    "/forgot-password",
    "/verify",
    "/reset",
    "/email-verification",
  ];

  useEffect(() => {
    const currentPath = location.pathname;
    const shouldShowChatBot = !excludedPaths.includes(currentPath);

    setShowChatBot(shouldShowChatBot);
  }, [location.pathname, excludedPaths]);

  if (!showChatBot) {
    return null;
  }
  return <ChatBot />;
};

export default ChatBotWrapper;
